import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent, actionNames } from "@newsela/snitch";
import { disabledButtonCss } from "../Actions.style";
import getButtonProps from "../utils/getButtonProps";
import useEventProperties from "../utils/useEventProperties";

const ButtonWithTrackEvent = withTrackEvent(Button);

const propTypes = {
  annotationId: PropTypes.number,
  buttonFlavor: PropTypes.string,
  isActionPending: PropTypes.bool,
  handleSave: PropTypes.func,
  isCommentEditMode: PropTypes.bool,
  isReply: PropTypes.bool,
};

const SaveButton = ({
  annotationId,
  buttonFlavor,
  isActionPending,
  handleSave,
  isCommentEditMode,
  isReply,
}) => {
  const description = isReply ? "Add an annotation comment" : "Save annotation";
  const eventProperties = useEventProperties(
    annotationId,
    actionNames.add,
    description,
  );

  return (
    <ButtonWithTrackEvent
      __cssFor={{ root: disabledButtonCss(isCommentEditMode, isActionPending) }}
      disabled={isActionPending}
      onClick={handleSave}
      {...getButtonProps(buttonFlavor)}
      {...eventProperties}
    >
      {isReply ? "Reply" : "Save"}
    </ButtonWithTrackEvent>
  );
};

SaveButton.propTypes = propTypes;

export default SaveButton;
